import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=4151a6c1&scoped=true"
import script from "./orderDetail?vue&type=script&lang=js&external"
export * from "./orderDetail?vue&type=script&lang=js&external"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=4151a6c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4151a6c1",
  null
  
)

export default component.exports